import { HttpParams } from "@angular/common/http";
import { Component, NgZone, OnInit, TemplateRef, HostListener } from "@angular/core";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../../global/global";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { FormGroup,  FormBuilder, Validators } from "@angular/forms";
import *  as CONSTANT from "../../../services/constants";
import { ToastrService } from "ngx-toastr";
import swal from "sweetalert2";
import { UserDetailsService } from "src/app/services/user/user-details.service";
import { ViewportScroller } from "@angular/common";
import { Subject } from "rxjs";

@Component({
  selector: "app-address",
  templateUrl: "./address.component.html",
  styleUrls: ["./address.component.css"]
})
export class AddressComponent implements OnInit {
  allStates:any=[];
  allAddress:any=[];
  showError:boolean=false;
  form: FormGroup;   
  prodId: any;
  allData: any;
  userData: any;  
  topPosToStartShowing = 100;
  
  subscriptionId: any=[];
  subscriptionObserver = new Subject<string>();
  constructor(private modalService: BsModalService,public router: Router,private route: ActivatedRoute,private api: AdminService,private formBuilder: FormBuilder,private _zone: NgZone,private toastrService: ToastrService,private userDetailsService: UserDetailsService,private scroller: ViewportScroller ) {
   
    this.form = this.formBuilder.group({
      firstName : ["", [Validators.required, Validators.minLength(3)]],
      lastName : ["", [Validators.required, Validators.minLength(3)]],
      companyName: ["", Validators.compose([Validators.required])],
      countryCode: ["+1"],
      phoneNumber : ["", [Validators.required, Validators.minLength(10)]],
      address : ["", [Validators.required]], 
      state : ["", [Validators.required]], 
      city : ["", [Validators.required]], 
      zipCode : ["", [Validators.required]],  
      countryName : ["", [Validators.required]], 
    })   
    this.onTop();  
   }
   @HostListener('window:scroll')
   checkScroll() {
     const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
 
   }
  ngOnInit(): void {  
    this.onTop();
    this.route.queryParams.subscribe(params => {
      this.subscriptionId = params['subscriptionId']; 
    });
    this.router.navigate(["/address" + this.prodId ]);
    this.prodId = this.route.snapshot.paramMap.get("id");
    this.userData = localStorage.getItem("userId")
    this.getUserDetail();
    this.getState();
    this.getPlans();
    this.getAddress();
  } 
  //getUserDetail
  getUserDetail(){
    this.api.getDatas(apiUrl._getRecuriterDetail+"/"+this.userData)
    .subscribe(async (res) => {
      this.allData = res.data.Recruiter;
      console.log(this.allData,"this.allData");
      let firstname = "";
      let lastname = "";
      let nameSplit = this.allData.name.split(" ");
      if (nameSplit.length > 1) {
        firstname = nameSplit[0]
        lastname = nameSplit[1]
      } else {
        firstname = this.allData.name
        lastname = ""
      }
      
      this.form.patchValue({
        ...this.allData,
        firstName:firstname,
        lastName:lastname,
        countryName:this.allData.location,
      })
    })
  }
  onTop(){
    this.scroller.scrollToAnchor("targetRed");
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
  }
  getPlans(){
    let params = new HttpParams(); 
    params = params.append("id", this.prodId);
    this.api.getDetail(apiUrl._paymentPlanDetail+"/"+this.prodId,"")
    .subscribe(async (res) => {
      this.allData =res.data;
      if(this.allData.planType == 0){
        this.form.patchValue({
          subscriptionId: this.allData?.id,
        }) 
      } else{
        this.form.patchValue({
          inventoryId: this.allData?.id,
        })
      }
    })
   }
  //getState 
  getState(){
    this.api.getDatas(apiUrl._stateApi)
    .subscribe(async (res) => {
      console.log(res,'stats');
      this.allStates = res.data.rows;
    })
  }
  getAddress(){
    this.api.getDatas(apiUrl._billingAddress)
    .subscribe(async (res) => {
      this.allAddress = res.data;
      this.form.patchValue({
        ...this.allAddress,
        countryCode:"+1"
      })
    })
  }
  // check if only number
  preventNumbers(event): boolean { 
    event = (event) ? event : window.event;
    var charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
    }
    return true;
  }
  // remove empty filed
  removeEmptyFiled(form){
    const formValues = form.value;
    const formKeys = Object.keys(formValues);
    if (formKeys.length) {
      for (let i = 0; i < formKeys.length; i++) {
        if (
          formValues[formKeys[i]] == null ||
          formValues[formKeys[i]] == undefined ||
          formValues[formKeys[i]] == ""
        ) {
          delete formValues[formKeys[i]];
        }
      }
    }

    return formValues
  }
  // on submit order
  onOrderSubmit(){
    this.form.value.countryCode= "+1"; 
    this.api.stopLoader(); 
    if(this.form.valid){
      if( this.allData.planType == 0){
          this.api.putData(apiUrl._addBillingAddress, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => { 
        this.router.navigateByUrl(`/checkout/${this.prodId}`);
        })
      } else{
        this.api.putData(apiUrl._addBillingAddress, this.removeEmptyFiled(this.form))
        .subscribe(async (res) => { 
        this.router.navigateByUrl(`/checkout/${this.prodId}`);
        })
      }
    } else{
      this.showError=true;
      setTimeout(() => {
        this.showError=false;
      }, 3000);
    }
  } 
  // back
  goToBack(id){
    this.subscriptionId=id
    let queryparams = {}
    queryparams["subscriptionId"] = this.subscriptionId; 
    this.router.navigate(['subscription'], { queryParams: {subscriptionId: this.subscriptionId} })
  }
}
